type Props = {
  kicker?: string
  title: string
  dek?: string
  subtitle?: string
  className?: string
}

export default function PageHeader({ kicker, title, dek, subtitle, className = '' }: Props) {
  return (
    <header data-reveal className={className}>
      {kicker ? <p className="text-caps text-rose">{kicker}</p> : null}
      <h1 className="text-caps-hero mt-3 m-0 text-balance text-ink">{title}</h1>
      {subtitle ? <p className="text-caps-h3 mt-4 m-0 text-ink">{subtitle}</p> : null}
      {dek ? <p className="mt-5 m-0 max-w-[46ch] leading-relaxed text-copy">{dek}</p> : null}
    </header>
  )
}
